import React, { ChangeEvent, FC, ReactNode } from 'react';

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { styled } from '@mui/material';

import { MIDDLE_MARGIN_PX, SMALL_MARGIN_PX } from '~/theme';

interface VideoAccordionProps {
  expanded?: boolean;
  onChange?: (event: ChangeEvent<{}>, expanded: boolean) => void;
  children: NonNullable<ReactNode>;
}

const VideoAccordion: FC<VideoAccordionProps> = ({ children, expanded, onChange }) => {
  return children ? (
    <StyledAccordion expanded={expanded} onChange={onChange}>
      {children[0] && (
        <StyledAccordionSummary>
          <AccordionIconBlock active={!!expanded} />
          {children[0]}
        </StyledAccordionSummary>
      )}
      {children[1] && <StyledAccordionDetails>{children[1]}</StyledAccordionDetails>}
    </StyledAccordion>
  ) : null;
};

export default VideoAccordion;

const StyledAccordion = styled(Accordion)`
  background: ${({ theme }) => theme.palette.common.transparent};
  box-shadow: none;
  margin: 0;
  margin-bottom: ${SMALL_MARGIN_PX};
  &::before {
    display: none;
  }
  &.Mui-expanded {
    margin-top: 0;
    margin-bottom: 0;
    &:last-child {
      margin-bottom: ${MIDDLE_MARGIN_PX};
    }
  }
`;
const StyledAccordionSummary = styled(AccordionSummary)`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.common.white};
  border-bottom: 2px solid ${({ theme }) => theme.palette.common.violetAnalyticsCard};
  padding: 10px 0;
  margin: 0;
  min-height: 46px;
  &.Mui-expanded {
    color: ${({ theme }) => theme.palette.common.white};
    && {
      margin: 0;
      min-height: unset;
    }
  }
  & .MuiAccordionSummary-content {
    margin: 0;
    display: flex;
    align-items: center;
  }

  transition: 0.3s color;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.light};
  }
`;
const StyledAccordionDetails = styled(AccordionDetails)`
  padding: ${SMALL_MARGIN_PX} 0 0;
`;
const AccordionIconBlock = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>`
  margin-right: 13px;
  margin-left: 5px;
  width: 14px;
  height: 14px;
  position: relative;
  &::before {
    display: block;
    content: '';
    width: 14px;
    height: 2px;
    background: ${({ theme }) => theme.palette.primary.light};
    margin-top: 6px;
  }
  &::after {
    display: block;
    content: '';
    width: 14px;
    height: 2px;
    background: ${({ theme }) => theme.palette.primary.light};
    margin-top: -2px;
    transform: ${({ active }) => (active ? 'rotate(0deg)' : 'rotate(-90deg)')};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`;
